import { Dispatch, SetStateAction, useEffect } from "react";

export function useDraftGalleryAutoFill({
  groupCount, targetGroupCount, stable, hasMore, loading,
  visiblePostCount, limitCount, pageSize, setLimitCount,
}: {
  groupCount: number;
  targetGroupCount: number;
  stable: boolean;
  hasMore: boolean;
  loading: boolean;
  visiblePostCount: number;
  limitCount: number;
  pageSize: number;
  setLimitCount: Dispatch<SetStateAction<number>>;
}) {
  useEffect(() => {
    if (groupCount < targetGroupCount && stable && hasMore && !loading) {
      // Completed request groups can extend past the requested limit. Skip
      // their hidden failures and keep advancing even if the query is cached.
      setLimitCount((count) => Math.max(count, visiblePostCount) + pageSize);
    }
  }, [groupCount, targetGroupCount, stable, hasMore, loading,
    visiblePostCount, limitCount, pageSize, setLimitCount]);
}
